export const DEVTOOLS_SHADOW_DOM_ID = '__perf-monitor-devtools-container__';
export const DEVTOOLS_SHADOW_DOM_ROOT_ID = '__perf-monitor-devtools-root__';
export const DEVTOOLS_OPEN_EDITOR_ENDPOINT = '/__react-render-tracker__/open';
export const DEVTOOLS_READ_FILE_ENDPOINT = '/__react-render-tracker__/read';
export const DEVTOOLS_STANDALONE = '/__react-render-tracker__/standalone';
